/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import './DateInput.scss';
import clsx from 'classnames';

/**
 * DateInput component for date selection
 *
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new DateInput component from '@ui' instead.
 *
 * Migration path:
 * - Import: `import { DateInput } from '@ui';`
 * - API is compatible - same props structure
 * - Note: New component uses TypeScript and provides better type safety
 *
 * @see {@link frontend/ui/molecules/inputs/form/DateInput/DateInput.tsx}
 * @see {@link docs/ai-knowledge/frontend/component-deprecation-plan.md}
 */
function DateInput({ id, value, onChange, label, name, required, error }) {
  return (
    <div className={clsx('qmb-input dateInputContainer', { 'has-error': error })}>
      <DatePicker id={id} name={name} value={value} onChange={onChange} />
      <label htmlFor={id} className={clsx('qmb-label', { '--required': required })}>
        {label}
      </label>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export default DateInput;

DateInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string
};

DateInput.defaultProps = {
  onChange: () => {},
  name: '',
  value: '',
  label: '',
  required: false,
  error: null
};
